import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';

import { type LinkPricingApi, pricingLinksApiSchema } from '../../models';
import { logger } from '../../utils/logger';

const contracts = fetcher.extend(() => ({ prefixUrl: `${API.CONTRACTS}` }));

export const createContractPricing = async (
  payload: LinkPricingApi[],
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await contracts.post('contract-pricing/bulk-create', { json: payload, signal }).json(pricingLinksApiSchema);
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
